import React, { useEffect, useContext } from 'react';
import { NavLink, Outlet, useParams, useNavigate } from 'react-router-dom';
import { StudentContext } from '../StudentContext';
import './ClassList.css';

const ClassList = () => {
  const { blockId, classId } = useParams();
  const navigate = useNavigate();
  const { allBlocks, blocks, isLoading } = useContext(StudentContext);

  const allClasses = allBlocks[blockId] || [];
  const visibleClasses = blocks[blockId] || [];

  const visibleClassIds = visibleClasses.map((cls) => cls.id);

  useEffect(() => {
    if (!isLoading && !classId && visibleClasses.length > 0) {
      navigate(`/main/class-list/${blockId}/${visibleClasses[0].id}`, { replace: true });
    }
  }, [blockId, classId, visibleClasses, navigate, isLoading]);

  if (isLoading) {
    return <div className="loading-message">Đang tải danh sách lớp...</div>;
  }

  if (allClasses.length === 0) {
    return <div className="no-data-message">Không có lớp nào trong khối này.</div>;
  }

  return (
    <div className="class-list-container">
      {allClasses.length > 1 && (
        <div className="class-nav">
          {allClasses.map((classItem) => {
            const isAccessible = visibleClassIds.includes(classItem.id);
            return (
              <NavLink
                key={classItem.id}
                to={`/main/class-list/${blockId}/${classItem.id}`}
                className={({ isActive }) =>
                  isActive && isAccessible ? 'active' : isAccessible ? '' : 'disabled'
                }
              >
                {classItem.name}
              </NavLink>
            );
          })}
        </div>
      )}
      {visibleClasses.length === 1 && (
        <h3 className="single-class-title">{visibleClasses[0].name}</h3>
      )}
      <div className="class-content">
        <Outlet />
      </div>
    </div>
  );
};

export default ClassList;